export enum ETimezoneGroup {
  commonlyUsed = 'Commonly Used',
  usaCanada = 'USA + Canada',
  europe = 'Europe',
  asiaPacific = 'Asia & Pacific',
  other = 'Other',
}

export const TIMEZONE_GROUP_ORDER = [
  ETimezoneGroup.commonlyUsed,
  ETimezoneGroup.usaCanada,
  ETimezoneGroup.europe,
  ETimezoneGroup.asiaPacific,
  ETimezoneGroup.other,
] as const

/** Most-used US zones, ordered as Eastern → Central → Mountain → Arizona → Pacific */
export const COMMON_TIMEZONE_VALUES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
] as const

export const USA_CANADA_TIMEZONES = new Set([
  'America/Anchorage',
  'America/Blanc-Sablon',
  'America/Boise',
  'America/Cambridge_Bay',
  'America/Chicago',
  'America/Creston',
  'America/Dawson',
  'America/Dawson_Creek',
  'America/Denver',
  'America/Detroit',
  'America/Edmonton',
  'America/Glace_Bay',
  'America/Goose_Bay',
  'America/Halifax',
  'America/Indiana/Knox',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Tell_City',
  'America/Indiana/Vevay',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Indianapolis',
  'America/Inuvik',
  'America/Iqaluit',
  'America/Juneau',
  'America/Kentucky/Monticello',
  'America/Los_Angeles',
  'America/Louisville',
  'America/Menominee',
  'America/Moncton',
  'America/Montreal',
  'America/New_York',
  'America/Nipigon',
  'America/Nome',
  'America/North_Dakota/Beulah',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/Pangnirtung',
  'America/Phoenix',
  'America/Rainy_River',
  'America/Rankin_Inlet',
  'America/Regina',
  'America/Resolute',
  'America/Sitka',
  'America/St_Johns',
  'America/Swift_Current',
  'America/Thunder_Bay',
  'America/Toronto',
  'America/Vancouver',
  'America/Whitehorse',
  'America/Winnipeg',
  'America/Yakutat',
  'America/Yellowknife',
  'Pacific/Honolulu',
  'Pacific/Johnston',
])
